/* BIA shop layer — Quick Add + filter/sort drawers.
   Product data is fetched on demand from /products/<handle>.js and cached for
   the session, so no product JSON is embedded at page load.
   Nothing essential is hidden behind JS: cards still link to product pages and
   the collection filter/sort forms still submit normally. */
(function () {
  var CACHE = {};
  var lastTrigger = null;

  function money(cents) {
    var f = (window.BIA_MONEY_FORMAT || 'Rs {{amount}}');
    var n = (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    return f.replace(/\{\{[^}]*\}\}/, n).replace('Rs.', 'Rs ');
  }

  function getProduct(handle) {
    if (CACHE[handle]) return Promise.resolve(CACHE[handle]);
    return fetch('/products/' + handle + '.js')
      .then(function (r) { if (!r.ok) throw new Error('load'); return r.json(); })
      .then(function (p) { CACHE[handle] = p; return p; });
  }

  /* ---------- generic sheet ---------- */
  function sheet() {
    var el = document.querySelector('[data-bia-sheet]');
    if (el) return el;
    el = document.createElement('div');
    el.className = 'bsheet';
    el.setAttribute('data-bia-sheet', '');
    el.setAttribute('hidden', '');
    el.innerHTML = '<button class="bsheet__ov" type="button" tabindex="-1" aria-hidden="true"></button>' +
      '<div class="bsheet__p" role="dialog" aria-modal="true" aria-label="Quick add"><div data-bia-sheet-body></div></div>';
    document.body.appendChild(el);
    el.querySelector('.bsheet__ov').addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !el.hasAttribute('hidden')) close();
      if (e.key === 'Tab' && !el.hasAttribute('hidden')) trap(e, el);
    });
    return el;
  }

  function trap(e, el) {
    var f = el.querySelectorAll('a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function open(html, label) {
    var el = sheet();
    el.querySelector('.bsheet__p').setAttribute('aria-label', label || 'Quick add');
    el.querySelector('[data-bia-sheet-body]').innerHTML = html;
    el.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () { el.classList.add('is-open'); });
    var f = el.querySelector('button:not(.bsheet__ov),a[href]');
    if (f) f.focus();
    return el;
  }

  function close() {
    var el = document.querySelector('[data-bia-sheet]');
    if (!el || el.hasAttribute('hidden')) return;
    el.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { el.setAttribute('hidden', ''); }, 300);
    if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
  }

  /* ---------- Quick Add ---------- */
  function optIndex(p, name) {
    for (var i = 0; i < p.options.length; i++) {
      var n = (p.options[i].name || p.options[i]).toString().toLowerCase();
      if (n === name) return i;
    }
    return -1;
  }

  function render(p) {
    var ci = optIndex(p, 'colour'); if (ci < 0) ci = optIndex(p, 'color');
    var si = optIndex(p, 'size');
    var colours = [], sizes = [];
    p.variants.forEach(function (v) {
      if (ci > -1 && colours.indexOf(v.options[ci]) < 0) colours.push(v.options[ci]);
      if (si > -1 && sizes.indexOf(v.options[si]) < 0) sizes.push(v.options[si]);
    });
    var img = (p.featured_image || '');
    var sub = '';
    var h = '<div class="qa" data-qa data-handle="' + p.handle + '" data-ci="' + ci + '" data-si="' + si + '">' +
      '<div class="qa__top">' +
        (img ? '<img class="qa__img" data-qa-img src="' + img + '&width=200" alt="" width="72" height="90">' : '') +
        '<div class="qa__meta"><p class="qa__n">' + p.title + '</p>' +
        (sub ? '<p class="qa__s">' + sub + '</p>' : '') +
        '<p class="qa__p" data-qa-price>' + money(p.price) + '</p></div>' +
        '<button class="qa__x" type="button" data-qa-close aria-label="Close">&times;</button>' +
      '</div>';

    if (colours.length > 1) {
      h += '<fieldset class="qa__grp"><legend>Colour: <b data-qa-cname>' + colours[0] + '</b></legend><div class="qa__row">';
      colours.forEach(function (c, i) {
        h += '<button type="button" class="qa__chip" data-qa-colour="' + c.replace(/"/g, '') + '"' + (i === 0 ? ' aria-pressed="true"' : ' aria-pressed="false"') + '>' + c + '</button>';
      });
      h += '</div></fieldset>';
    }
    if (sizes.length) {
      h += '<fieldset class="qa__grp"><legend>Size</legend><div class="qa__row">';
      sizes.forEach(function (s) {
        h += '<button type="button" class="qa__chip qa__chip--sz" data-qa-size="' + s.replace(/"/g, '') + '" aria-pressed="false">' + s + '</button>';
      });
      h += '</div></fieldset>';
    }
    h += '<p class="qa__avail" data-qa-avail>Select a size</p>' +
      '<button type="button" class="qa__add" data-qa-add disabled>Add to Bag</button>' +
      '<p class="qa__note">Each piece is secured to order. We confirm sizing and timing before dispatch.</p>' +
      '<a class="qa__full" href="/products/' + p.handle + '">View full details</a></div>';
    return h;
  }

  function wire(p) {
    var root = document.querySelector('[data-qa]');
    if (!root) return;
    var ci = parseInt(root.dataset.ci, 10), si = parseInt(root.dataset.si, 10);
    var state = { colour: null, size: null };
    var cs = root.querySelectorAll('[data-qa-colour]');
    if (cs.length) state.colour = cs[0].dataset.qaColour;
    var addBtn = root.querySelector('[data-qa-add]');
    var avail = root.querySelector('[data-qa-avail]');
    var priceEl = root.querySelector('[data-qa-price]');
    var imgEl = root.querySelector('[data-qa-img]');

    function match() {
      return p.variants.filter(function (v) {
        var ok = true;
        if (ci > -1 && state.colour) ok = ok && v.options[ci] === state.colour;
        if (si > -1 && state.size) ok = ok && v.options[si] === state.size;
        return ok;
      })[0] || null;
    }

    function sync() {
      /* disable sizes that do not exist for the chosen colour */
      root.querySelectorAll('[data-qa-size]').forEach(function (b) {
        var s = b.dataset.qaSize;
        var v = p.variants.filter(function (x) {
          var ok = x.options[si] === s;
          if (ci > -1 && state.colour) ok = ok && x.options[ci] === state.colour;
          return ok;
        })[0];
        var usable = !!(v && v.available);
        b.disabled = !usable;
        b.setAttribute('aria-disabled', String(!usable));
      });
      var v = match();
      if (v && priceEl) priceEl.textContent = money(v.price);
      if (v && v.featured_image && imgEl) imgEl.src = v.featured_image.src + '&width=200';
      var ready = !!(v && v.available && (si < 0 || state.size));
      addBtn.disabled = !ready;
      if (!state.size && si > -1) avail.textContent = 'Select a size';
      else if (!v || !v.available) avail.textContent = 'Not available in this combination';
      else avail.textContent = 'Available to Order';
    }

    root.addEventListener('click', function (e) {
      var c = e.target.closest('[data-qa-colour]');
      var s = e.target.closest('[data-qa-size]');
      var x = e.target.closest('[data-qa-close]');
      if (x) { close(); return; }
      if (c) {
        state.colour = c.dataset.qaColour;
        cs.forEach(function (b) { b.setAttribute('aria-pressed', String(b === c)); });
        var nm = root.querySelector('[data-qa-cname]'); if (nm) nm.textContent = state.colour;
        sync();
      }
      if (s && !s.disabled) {
        state.size = s.dataset.qaSize;
        root.querySelectorAll('[data-qa-size]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === s)); });
        sync();
      }
    });

    addBtn.addEventListener('click', function () {
      var v = match();
      if (!v || !v.available) return;
      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: v.id, quantity: 1 })
      }).then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () {
          addBtn.textContent = 'Added to Bag';
          document.querySelectorAll('[data-cart-count]').forEach(function (n) {
            n.hidden = false; n.textContent = (parseInt(n.textContent, 10) || 0) + 1;
          });
          setTimeout(close, 900);
        })
        .catch(function () {
          addBtn.disabled = false;
          addBtn.textContent = 'Add to Bag';
          avail.textContent = 'Could not add just now. Please try again.';
        });
    });

    sync();
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-bia-quickadd]');
    if (!t) return;
    e.preventDefault();
    lastTrigger = t;
    var handle = t.getAttribute('data-bia-quickadd');
    open('<p class="qa__load">Loading…</p>', 'Quick add');
    getProduct(handle).then(function (p) {
      open(render(p), p.title);
      wire(p);
    }).catch(function () {
      open('<p class="qa__load">This piece could not be loaded. <a href="/products/' + handle + '">Open the product page</a>.</p>', 'Quick add');
    });
  });
})();
